var __jsx = React.createElement;
import React from "react";
import AwesomeIcon from "../../AwesomeIcon";
import { faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { faMessageBot } from "@fortawesome/pro-duotone-svg-icons";
import PatientSummary from "../../Chat/Message/PatientSummary";
var CustomAssistantMessage = function CustomAssistantMessage(props) {
  var message = props.message,
    isLoading = props.isLoading,
    subComponent = props.subComponent;
  var loadingKeys = ["Analyzing clinical context...", "Compiling patient data...", "Processing medical records...", "Interpreting inputs...", "Reviewing patient information...", "Gathering relevant details...", "Synchronizing with medical database..."];
  var currentIndex = Math.floor(Math.random() * loadingKeys.length);
  var jsonMatchMarkdown = message === null || message === void 0 ? void 0 : message.match(/```(?:json)?\s*([\s\S]*)/i);
  return /*#__PURE__*/React.createElement(React.Fragment, null, message && /*#__PURE__*/React.createElement("div", {
    className: "flex items-start mb-4 last:mb-0 justify-start"
  }, !subComponent && /*#__PURE__*/React.createElement("div", {
    className: "p-1 mt-2 rounded-full border-0 border-teal-300 flex items-center justify-center mr-2 flex-shrink-0"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faMessageBot,
    size: "lg",
    className: "text-teal-300"
  })), message.startsWith("{") || jsonMatchMarkdown ? /*#__PURE__*/React.createElement(PatientSummary, {
    message: message
  }) : /*#__PURE__*/React.createElement("div", {
    className: "px-5 py-4 rounded-lg max-w-[75%] bg-gray-800 text-white rounded-tl-none"
  }, /*#__PURE__*/React.createElement("p", {
    className: "whitespace-pre-wrap"
  }, message))), /*#__PURE__*/React.createElement("div", {
    className: "ml-4 mb-6 my-2"
  }, subComponent), isLoading && /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-3 text-gray-400 pl-8"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faSpinner,
    size: "lg",
    className: "animate-spin"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-md italic"
  }, loadingKeys[currentIndex])));
};
export default CustomAssistantMessage;